import { useLocalStorage } from '@vueuse/core'
import { defineStore } from 'pinia'
import { AppState } from './app.interface'

const useAppStore = defineStore('app', {
  state: (): AppState => ({
    theme: 'auto',
    breadcrumbList: [],
    authList: JSON.parse(localStorage.getItem('authList') || '[]'),
    routeChainList: [],
    fallbackPath: null,
    menuList: JSON.parse(localStorage.getItem('menuList') || '[]'),
    sidebarStatus: useLocalStorage<'open'|'close'>('sidebarStatus', 'close'),
    mobileScreenMode: window.innerWidth <= 768,
    padScreenMode: window.innerWidth > 768 && window.innerWidth <= 996,
    padHorScreenMode: window.innerWidth > 996 && window.innerWidth <= 1200,
    desktopScreenMode: window.innerWidth > 1200 && window.innerWidth <= 1920
  }),

  getters: {
    includeKeepAlive (state) {
      return Array.from(new Set(state.routeChainList.filter(route => route.meta?.keepAlive).map(route => route.name))).join(',')
    }
  },

  actions: {
    // Update app settings
    // updateSettings (partial: Partial<AppState>) {
    //   this.$patch(partial)
    // },

    // Change theme color
    toggleTheme (dark: boolean) {
      if (dark) {
        this.theme = 'dark'
        document.body.setAttribute('arco-theme', 'dark')
      } else {
        this.theme = 'light'
        document.body.removeAttribute('arco-theme')
      }
    }
  }
})

export default useAppStore
